import { render, staticRenderFns } from "./companyIntroduction.vue?vue&type=template&id=788f7ca8&scoped=true"
import script from "./companyIntroduction.vue?vue&type=script&lang=js"
export * from "./companyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./companyIntroduction.vue?vue&type=style&index=0&id=788f7ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f7ca8",
  null
  
)

export default component.exports